import client from "./client";

export const authenticateRequestCode = async (username, type = "login") => {
  const body = {
    owner: username,
    ownerType: "email",
    type: type,
  };

  return client.post("/user/security/code/request", body);
};

export const authenticateVerifyCode = async (
  username,
  code,
  type = "login"
) => {
  const body = {
    owner: username,
    ownerType: "email",
    type: type,
    code: code,
  };

  return client.post("/user/security/code/verify", body);
};
